import { Box, withStyles } from '@material-ui/core';
import { Skeleton as MUISkeleton } from '@material-ui/lab';

const Skeleton = withStyles({
  root: {
    width: '100%',
    height: 92,
    borderRadius: 8,
    backgroundColor: '#E6E6E6 !important'
  }
})(MUISkeleton);

export const MobileResourceLoader = () => (
  <Box display="flex" flexDirection="column" gridGap="8px">
    {Array.from(new Array(5)).map((_, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <Skeleton key={i} variant="rect" />
    ))}
  </Box>
);
